import React, { useState } from "react";
import axiosInstance from "axios";
import { LoadingButton } from "../../Utils/CustomComponent";
import { selected_authentication_server } from "../../deployment-config";
import { useForm } from "react-hook-form";
import FormBox from "../../components/FormBox/FormBox";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import { Background } from "../Login/LoginComp";

const AdmissionFormComp = () => {
  const [disableBtn, setDisableBtn] = useState();

  const { register, handleSubmit, watch, setValue } = useForm();

  const onSubmit = async (data) => {
    data.STATUS = "NEW";
    const id = toast.loading("Admission request is being processed...");
    setDisableBtn(true);
    try {
      const res = await axiosInstance.post(
        selected_authentication_server.new_user_admission.endpoint,
        data,
        selected_authentication_server.new_user_admission.headers
      );
      if (res.status == 200 || res.statusText == "OK") {
        toast.update(id, {
          render: "Request Submitted Succesfuly",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        setDisableBtn(false);
      }
    } catch (error) {
      console.error(error);
      setDisableBtn(false);
    } finally {
      setTimeout(() => {
        toast.dismiss();
      }, 1000);
    }
  };

  return (
    <Background>
      <div className="d-flex flex-column">
        <h3 className="mb-4">New user admission request</h3>
        <FormBox
          options={checkingFormArr}
          register={register}
          watch={watch}
          setValue={setValue}
        />
        <p>
          By submitting you acknowledge you have read and agree yo our Privacy
          Policy
        </p>
        <LoadingButton
          className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
          type="button"
          onClick={handleSubmit(onSubmit)}
          disabled={disableBtn}
          loading={disableBtn}
          title="Send Request"
        />
      </div>
    </Background>
  );
};
export default AdmissionFormComp;

const UserOptions = [
  { label: "Broker", value: "Broker" },
  { label: "Lender", value: "Lender" },
];
const checkingFormArr = [
  {
    title: "First Name *",
    field: "FIRST_NAME",
    type: "text",
  },
  {
    title: "Last Name *",
    field: "LAST_NAME",
    type: "text",
  },
  {
    title: "Email Address *",
    field: "EMAIL",
    type: "text",
  },
  {
    title: "Phone Number *",
    field: "PHONE",
    type: "phoneNumber",
  },
  {
    title: "Current number of active loans *",
    field: "ACTIVE_LOANS",
    type: "number",
  },
  {
    title: "Submit request as *",
    field: "REQUEST_TYPE",
    type: "select",
    options: UserOptions,
  },
  {
    title: "What is your current system *",
    field: "CURRENT_SYSTEM",
    type: "text",
  },
  {
    title: "How did you hear about us *",
    field: "HEARED_FROM",
    type: "textarea",
  },
  {
    title: "Message *",
    field: "MESSAGE",
    type: "textarea",
  },
];
